import React, { useState, useEffect } from 'react';
import {
	DpCerrarSX,
	DpContentCardSX,
	DpHiddenSX,
	DpImageSX,
	DpLinkSX,
} from '@/components/blocks/DpLibrary/DpFloatingCard/style';
import { Img } from '@/components/blocks/MaterialImage';
import { Box, BoxProps, Link, SxProps, Typography } from '@mui/material';
import { combineSX } from '@/utils/combineSX';

type DpFloatingCardProps = BoxProps & {
	href?: string;
	img: string;
	alt?: string;
	xscard?: SxProps;
	example?: boolean;
};

export const DpFloatingCard = ({ href, img, alt, example }: DpFloatingCardProps) => {
	const [isBannerVisible, setIsBannerVisible] = useState(false);

	const setLocalStorage = (key: string, value: string) => {
		const nextMidnight = new Date();
		nextMidnight.setHours(24, 0, 0, 0);
		const expires = nextMidnight.getTime();
		localStorage.setItem(key, JSON.stringify({ value, expires }));
	};

	const getLocalStorage = (key: string) => {
		const itemStr = localStorage.getItem(key);
		if (!itemStr) {
			return null;
		}
		const item = JSON.parse(itemStr);
		const now = new Date();
		if (now.getTime() > item.expires) {
			localStorage.removeItem(key);
			return null;
		}
		return item.value;
	};

	useEffect(() => {
		if (!getLocalStorage('bannerClosed')) {
			setIsBannerVisible(true);
		}
	}, []);

	const handleClose = () => {
		setIsBannerVisible(false);
		setLocalStorage('bannerClosed', 'true');
	};

	return (
		<Box
			component="div"
			id="banner-home"
			sx={combineSX([
				DpContentCardSX(example ?? false),
				!example ? !isBannerVisible && DpHiddenSX : null,
			])}
		>
			<Link href={href ?? ''} sx={DpLinkSX}>
				<Img src={img} alt={alt ?? ''} sx={DpImageSX} />
			</Link>
			<Typography component="span" id="cerrar-banner-home" sx={DpCerrarSX} onClick={handleClose}>
				<Img
					alt="cerrar"
					src="https://dpjye2wk9gi5z.cloudfront.net/wcsstore/AuroraStorefrontAssetStore/images/jersey/cerrar.png"
				/>
			</Typography>
		</Box>
	);
};
